import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { isA, getStrValue, isReporter } from "../../store/utility";
import CellStatus from "../../components/UI/Widget/CellStatus";
import RequestContact from "../../components/UI/Widget/RequestContact";

import {
  addRequestMessage,
  fetchRequest,
  fetchContacts,
} from "../../store/actions/index";
import axios from "../../axios-atis";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import Loader from "react-loader-spinner";

import {
  Breadcrumb,
  Panel,
  FormGroup,
  Col,
  FormControl,
  Form,
  ControlLabel,
  Tabs,
  Tab,
} from "react-bootstrap";

import RequestTab from "./Tab/RequestTab";
import PlanedTab from "./Tab/PlanedTab";
import ClientResponseTab from "./Tab/ClientResponseTab";

class ClientReponse extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    var idLocale = require("moment/locale/fr");
    moment.locale("id", idLocale);

    this.state = {
      request: null,
      contacts: null,
      contactsForSend: null,
      canPlanned: false,
      plannedDate: null,
      plannedResume: null,
      interventionDate: null,
      interventionResume: null,
      requestId: null,
      loaded: true,
      activeKey: "1",
    };
  }
  componentDidMount = () => {
    this._isMounted = true;

    this.props.dispatch(fetchRequest(this.props.match.params.number));
    this.props.dispatch(fetchContacts());
    this.handleSelect = this.handleSelect.bind(this);
  };
  componentWillUnmount() {
    this._isMounted = false;
  }
  //Lifecycle
  componentWillReceiveProps(nextProps) {
    this.setState({ requestId: nextProps.match.params.number });

    if (this.state.request !== nextProps.request) {
      this.setState({ request: nextProps.request });
    }
    if (this.state.contacts !== nextProps.contacts) {
      this.setState({ contacts: nextProps.contacts });
    }
    if (this.state.loaded !== nextProps.loaded) {
      this.setState({ loaded: nextProps.loaded });
    }
  }
  setContacts = (contacts) => {
    this.setState({ contactsForSend: contacts });
  };
  //Form Update
  inputChangeHandler = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  //getContact
  getMyContacts = () => {
    var _contacts = [];
    var contactsSrc = this.state.contacts;
    if (this.state.contactsForSend !== null) {
      contactsSrc = this.state.contactsForSend;
    }
    for (var i = 0; i < contactsSrc.length; i++) {
      _contacts.push({ id: contactsSrc[i].value, email: contactsSrc[i].label });
    }

    return _contacts;
  };
  //Envoyer un courriel
  handlerCancel = (event) => {
    event.preventDefault();
  };
  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  sendMessageToAtis = (value) => {
    var requestMessage = {
      message: value.message,
      contacts: this.getMyContacts(),
    };
    this.props.dispatch(addRequestMessage(this.state.request, requestMessage));
  };

  render() {
    var { request, contacts, loaded } = this.state;

    if (null === request || null === contacts || loaded) {
      return (
        <div align="center">
          <Loader type="ThreeDots" color="#00BFFF" height="100" width="100" />
        </div>
      );
    }
    const canUpdate = (isA() || isReporter()) && request.status !== 2;
    const plannedDate =
      request.predictedAt !== null
        ? moment(request.predictedAt, "DD/MM/YYYY")
        : null;
    return (
      <div className="content-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item href="/#/requests">Interventions</Breadcrumb.Item>
          <Breadcrumb.Item href={`/#/requests/${this.state.requestId}`}>
            Intervention n°{request.numRequest}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>&Eacute;dition</Breadcrumb.Item>
        </Breadcrumb>
        <Panel>
          <Panel.Body>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Titre
                </Col>
                <Col sm={10}>
                  <FormControl
                    type="text"
                    value={getStrValue(request.name)}
                    className="form-control"
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Société
                </Col>
                <Col sm={4}>
                  <FormControl
                    type="text"
                    value={getStrValue(request.company)}
                    className="form-control"
                    disabled
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  Site
                </Col>
                <Col sm={4}>
                  <FormControl
                    type="text"
                    value={getStrValue(request.section)}
                    className="form-control"
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Créée le
                </Col>
                <Col sm={4}>
                  <FormControl
                    type="text"
                    value={getStrValue(request.createdAt)}
                    className="form-control"
                    disabled
                  />
                </Col>

                <Col componentClass={ControlLabel} sm={2}>
                  Statut
                </Col>
                <Col sm={2} style={{ paddingTop: "5px" }}>
                  <CellStatus
                    requestStatus={request.status}
                    fontSize="1em"
                    align="left"
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Envoyé à
                </Col>
                <Col sm={10}>
                  <RequestContact
                    contacts={contacts}
                    requestContacts={request.contacts}
                    setContacts={(value) => this.setContacts(value)}
                    canUpdate={canUpdate}
                  />
                </Col>
              </FormGroup>
            </Form>

            <Tabs id="wf-tab" defaultActiveKey={3}>
              <Tab eventKey={1} title="Demande">
                <RequestTab requestResume={request.request} />
              </Tab>
              {null !== plannedDate || canUpdate ? (
                <Tab eventKey={2} title="Planification">
                  <PlanedTab
                    request={request}
                    canUpdate={false}
                    plannedDate={plannedDate}
                    updResponse={null}
                  />
                </Tab>
              ) : null}
              <Tab eventKey={3} title="Échanges client">
                <ClientResponseTab
                  request={request}
                  canUpdate={false}
                  plannedDate={plannedDate}
                  requestMessage={null}
                  sendMessageToAtis={(value) => this.sendMessageToAtis(value)}
                />
                {this.state.request.requestMessages
                  .reverse()
                  .map((requestMessage, i) => {
                    if (
                      requestMessage.message != null &&
                      requestMessage.message.length > 0
                    ) {
                      return (
                        <Panel key={i}>
                          <Panel.Heading style={{ backgroundColor: "#23b7e5" }}>
                            Correspondance du {requestMessage.createdAt}
                          </Panel.Heading>
                          <Panel.Body>{requestMessage.message}</Panel.Body>
                        </Panel>
                      );
                    } else {
                      return null;
                    }
                  })}
              </Tab>
            </Tabs>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    error: state.contact.error,
    loaded: state.contact.loading || state.request.loading,
    company: state.auth.company,
    contacts: state.contact.contacts,
    request: state.request.request,
  };
};

export default connect(mapStateToProps)(withErrorHandler(ClientReponse, axios));



// WEBPACK FOOTER //
// ./src/containers/Request/ClientResponse.js